<template>
  <div class="personalized-questions">
    <div class="personalized-questions__content">
      <div v-if="isLoading" class="loading-wrapper">
        <ReLoading :color="color" />
        <div class="loading-wrapper__title">
          Carregando formulário de perguntas
        </div>
        <div class="loading-wrapper__text">
          Isto pode levar alguns segundos
        </div>
      </div>
      <questions-form v-else :forms="forms" :answers="answers" :answered="answered" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.personalized-questions {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.personalized-questions__content {
  width: 95%;
  margin: 16px auto 10px;
  display: flex;
  justify-content: center;
  background-color: #fff;
}

.loading-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 100px);

  &__title {
    font-weight: 500;
    font-size: 18px;
    line-height: 100%;
    letter-spacing: 0%;
    text-align: center;
    color: #4f4f4f;
  }

  &__text {
    font-size: 14px;
    color: #696969;
  }
}
</style>

<script>
import { isEmpty, set, get } from "lodash";
import { pipe } from "lodash/fp";
import QuestionsForm from "./components/QuestionsForm.vue";
import ReLoading from "../../../components/re-loading/ReLoading.vue";
import { mapState } from "vuex";

export default {
  components: { QuestionsForm, ReLoading },
  data: () => ({
    forms: [],
    answers: {},
    answered: [],
    isLoading: true,
  }),
  computed: {
    ...mapState("company", ["company"]),
    color() {
      return this.company.base_hexcolor || "#1551b1";
    },
  },
  methods: {
    setAnsweredQuestions(forms) {
      forms.forEach(form => {
        form.questions.forEach(({ answer }) => {
          if (isEmpty(answer.value)) return;

          this.answered = [
            ...this.answered,
            {
              question_id: answer.id,
              value: answer.answer.value
            }
          ];
        });
      });

      return forms;
    },
    setOnlyNotAnsweredQuestions(forms) {
      forms.forEach(form =>
        form.questions.forEach(question => {
          if (!isEmpty(question.answer.value)) return;
          set(this.answers, question._id, {
            question_id: question._id,
            value: question.answer.value || ""
          });
        })
      );

      return forms;
    },
    getOnlyUnanswaredQuestionsInForms(forms) {
      if (!forms.length) return [];

      this.forms = forms.map(form => ({
        ...form,
        questions: form.questions.filter(({ answer }) => isEmpty(answer.value))
      }));

      return forms;
    },
    shouldRedirectToNextStep(forms) {
      const questions = forms.map(form => form.questions).flat();
      if (questions.length === this.answered.length) {
        const { params } = this.$router.history.current;
        this.$router.push({
          name: "dashboard-vacancy",
          params,
          query: {
            success: true,
          }
        });
      }
    },
    async fetchForms() {
      this.isLoading = true;

      try {
        const { vacancy_id, step_id } = this.$router.history.current.params;

        const response = await this.$http.get(
          `/api/v2/questions/steps/vacancies/${vacancy_id}/${step_id}?debug=true`
        );

        const { forms = [] } = response.data.data;

        pipe(
          this.setAnsweredQuestions,
          this.setOnlyNotAnsweredQuestions,
          this.getOnlyUnanswaredQuestionsInForms,
          this.shouldRedirectToNextStep
        )(forms);

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if ([304, 400, 404, 409].includes(get(error, "response.status", null))) {
          const { params } = this.$router.history.current;
          this.$router.push({
            name: "dashboard-vacancy",
            params,
            query: {
              success: true,
            }
          });
        }
      }
    }
  },
  created() {
    this.fetchForms();
  }
};
</script>
